// extracted by mini-css-extract-plugin
export default {"main":"XoKf9","text":"xm6zq"};